module.exports = __webpack_public_path__ + "img/synlawn.bab10ea.jpg";